import { Component, OnInit } from '@angular/core';
import { ClaimService } from '@app/feature-modules/claim/claim.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss']
})
export class ClaimComponent implements OnInit {

  constructor(
    public claimService: ClaimService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.subscribe(data => {
      let parms = data;
      if (parms != undefined && parms.step != undefined) {
        this.claimService.claimStep = parms.step;
      }
    })
  }

}
